import { render, staticRenderFns } from "./ProjectDetailLayout.vue?vue&type=template&id=49601fc1&scoped=true&"
import script from "./ProjectDetailLayout.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailLayout.vue?vue&type=style&index=0&id=49601fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49601fc1",
  null
  
)

export default component.exports